import api from './api';

export const lancamentosService = {
  async getByTurma(turmaId: number) {
    const { data } = await api.get(`/lancamentos/turma/${turmaId}`);
    return data;
  },

  async updateStatus(lancamentoId: number, status: string) {
    const { data } = await api.patch(`/lancamentos/${lancamentoId}/status`, { status });
    return data;
  },

  async updateNFSE(lancamentoId: number, dadosNFSE: { numeroNFSE?: string; numeroRPS?: string; nfseId?: number; dataEmissao?: string }) {
    const { data } = await api.patch(`/lancamentos/${lancamentoId}/nfse`, dadosNFSE);
    return data;
  },

  async removeNFSE(lancamentoId: number) {
    const { data } = await api.patch(`/lancamentos/${lancamentoId}/nfse/remove`);
    return data;
  },

  async cancelarNFSE(lancamentoId: number, motivo: string) {
    const { data } = await api.post(`/lancamentos/${lancamentoId}/nfse/cancelar`, { motivo });
    return data;
  },

  async emitirNFSE(lancamentoId: number) {
    const { data } = await api.post(`/lancamentos/${lancamentoId}/nfse/emitir`);
    return data;
  },

  async emitirParcelas(contratoId: number) {
    const { data } = await api.post(`/lancamentos/emitir/${contratoId}`);
    return data;
  },

  async emitirParcelasTurma(turmaId: number) {
    const { data } = await api.post(`/lancamentos/emitir-turma/${turmaId}`);
    return data;
  },

  async getRelatorioFinanceiro(anoLetivoId?: number) {
    const params = anoLetivoId ? { anoLetivoId } : {};
    const { data } = await api.get('/lancamentos/relatorio/financeiro', { params });
    return data;
  },

  async getRelatorioInadimplentes(anoLetivoId?: number, turmaId?: number) {
    const params: Record<string, number> = {};
    if (anoLetivoId) params.anoLetivoId = anoLetivoId;
    if (turmaId) params.turmaId = turmaId;
    const { data } = await api.get('/lancamentos/relatorio/inadimplentes', { params });
    return data;
  },

  async emitirNFSeTodasTurmas(): Promise<{ total: number; sucesso: number; falha: number }> {
    const { data } = await api.post('/lancamentos/nfse/emitir-todas');
    return data;
  },

  async atualizarStatus(): Promise<{
    totalAnalisados: number;
    atualizadosParaPago: number;
    atualizadosParaPendente: number;
    atualizadosParaAtrasado: number;
    atualizadosParaNaoFaturado: number;
    executadoEm: string;
  }> {
    const { data } = await api.post('/lancamentos/atualizar-status');
    return data;
  },
};

